import axios from 'axios';

export const transactions = {
  state:{
      transactions: [],
      transactionsbyid: [],
      claimTransactions: [],
      pendingTransactions: [],
      recentTransactions: [],
      myTransactions: [],
      manuallyVerified: [],
      transactionDetails:{}
  },
  mutations:{
      transaction(state, data){
          state.transactions = data.transactions
      },
      claimTransaction(state,data){
          state.claimTransactions = data.transactions
      },
      setPendingTransaction(state,data){
        state.pendingTransactions = data.transactions
      },
      setManuallyVerifiedTransaction(state,data){
        state.manuallyVerified = data.transactions
      },
      setMyTransactions(state,data){
        state.myTransactions = data.transactions
      },
      transactionsbyid(state, data){
        state.transactionsbyid = data
      },
      recentTransactions(state, data){
        state.recentTransactions = data.transactions
      },
      paymentRefDetails(state, data){
        state.transactionDetails = data
      }

  },
  actions:{
    getRecentTransactions: ({commit})=>{
      return new Promise((resolve, reject)=>{
        axios.get("/transaction?limit=5&status=Successful")
        .then(({status, data})=>{
          if(status === 200){
            resolve(data);
            commit("recentTransactions", data)
          }
        })
        .catch((error)=>{
          reject(error);
        });
      })
    },
      getTransactions: ({commit})=>{
          return new Promise((resolve, reject)=>{
              axios.get("/transaction?type=premium")
              .then(({status, data})=>{
                if(status === 200){
                  console.log(data)
                  resolve(data);
                  commit("transaction", data)
                }
              })
              .catch((error)=>{
                reject(error);
              });
            })
      },
      // get premium transactions with filter
      getPremiumTransactionFilter: ({commit}, payload)=>{
        return new Promise((resolve, reject)=>{
          axios.get(`/transaction?type=premium&status=${payload.status}`)
          .then(({status, data})=>{
            if(status === 200){
              console.log(data)
              resolve(data);
              commit("transaction", data)
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },
      getClaimTransactions: ({commit})=>{
          return new Promise((resolve, reject)=>{
              axios.get("/transaction?type=Claims")
              .then(({status, data})=>{
                if(status === 200){
                  resolve(data);
                  commit("claimTransaction", data)
                }
              })
              .catch((error)=>{
                reject(error);
              });
            })
      },
      // get claims transactions with filters
      getClaimTransactionFilter: ({commit}, payload)=>{
        return new Promise((resolve, reject)=>{
          axios.get(`/transaction?type=Claims&status=${payload.status}`)
          .then(({status, data})=>{
            if(status === 200){
              resolve(data);
              commit("claimTransaction", data)
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },
      getPendingTransaction: ({commit})=>{
        return new Promise((resolve, reject)=>{
            axios.get("/transaction?status=Pending")
            .then(({status, data})=>{
              console.log(data)
              if(status === 200){
                resolve(data);
                commit("setPendingTransaction", data)
              }
            })
            .catch((error)=>{
              reject(error);
            });
          })
      },
      getManuallyVerifiedTransaction: ({commit})=>{
        return new Promise((resolve, reject)=>{
            axios.get("/transaction?isManuallyVerified=1")
            .then(({status, data})=>{
              if(status === 200){
                resolve(data);
                commit("setManuallyVerifiedTransaction", data)
              }
            })
            .catch((error)=>{
              reject(error);
            });
        })
      },
      getMyTransactions: ({commit}, payload)=>{
        return new Promise((resolve, reject)=>{
          axios.get(`/transaction?username=${payload.username}`)
          .then(({status, data})=>{
            if(status === 200){
              resolve(data);
              commit("setMyTransactions", data)
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },
      TransactionsById: ({commit},payload)=>{
        return new Promise((resolve, reject)=>{
            axios.get("/transaction/"+payload)
            .then(({status, data})=>{
              if(status === 200){
                resolve(data)
                commit('transactionsbyid', data)
              }
            })
            .catch((error)=>{
              reject(error);
            })
        });  
      },
      GeneratePaymentRef: ({commit},payload)=>{
        console.log('here')
        return new Promise((resolve, reject)=>{
            axios.post("/transaction", payload)
            .then(({status, data})=>{
              if(status === 201){
                resolve(data)
                commit('paymentRefDetails', data)
              }
            })
            .catch((error)=>{
              reject(error);
            })
        });  
      },
      verifyTransactions: ({commit},payload)=>{
        console.log(payload)
        return new Promise((resolve, reject)=>{
        axios.post("/transaction/verify/", payload)
        .then(({status, data})=>{
          console.log(status)
          if(status === 200){
            resolve(data)
          }
        })
        .catch((error)=>{
          reject(error)
        })
        });  
      },
      cancelTransactions: ({commit},payload)=>{
        console.log(payload)
        return new Promise((resolve, reject)=>{
        axios.post("/transaction/pendingtrans/cancel", payload)
        .then(({status, data})=>{
          console.log(status)
          if(status === 200){
            resolve(data)
          }
        })
        .catch((error)=>{
          reject(error)
        })
        });  
      },
      continueOverTheCounterTrans: ({commit},payload)=>{
        return new Promise((resolve, reject)=>{
        axios.post("/transaction/verify/bankPayments", payload)
        .then(({status, data})=>{
          if(status === 200){
            resolve(data)
          }
        })
        .catch((error)=>{
          reject(error)
        })
        });  
      },
      Flutterwave: ({commit},payload)=>{
        return new Promise((resolve, reject)=>{
        axios.post("/transaction/verify/payments/payments_flutterwave", payload)
        .then(({status, data})=>{
          if(status === 200){
            resolve(data)
          }
        })
        .catch((error)=>{
          reject(error)
        })
        });  
      }

  }   
}